import { Observable, filter, take } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { IrisModalBase } from '../utils/iris-modal.base';
import { SkModalBase } from '@ngx-strakit/cdk';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface IrisModalI<TComponent = any, TResult = any> {
  dialogRef: MatDialogRef<TComponent, TResult>;
  onClose$: Observable<TResult>;
  onSuccess$: Observable<TResult>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class IrisModal<TComponent = any, TResult = any> implements IrisModalI<TComponent, TResult> {
  dialogRef: MatDialogRef<TComponent, TResult> = undefined;
  onClose$: Observable<TResult> = undefined;
  onSuccess$: Observable<TResult> = undefined;
  constructor(params: IrisModalI<TComponent, TResult>) {
    Object.assign(this, params);
  }

  static fromDialogRef<
    TResult = unknown,
    TComponent extends IrisModalBase<unknown, TResult> | SkModalBase<unknown, TResult> =
      | IrisModalBase<unknown, TResult>
      | SkModalBase<unknown, TResult>,
  >(dialogRef: MatDialogRef<TComponent, TResult>): IrisModal<TComponent, TResult> {
    const onClose$ = dialogRef.componentInstance.close$.pipe(
      take(1),
      filter(result => !result),
    );
    const onSuccess$ = dialogRef.componentInstance.result$.pipe(take(1));
    return new IrisModal({
      dialogRef,
      onClose$,
      onSuccess$,
    });
  }
}
